<template>
  <footer class="fw-semi br-top-dark flex-nowrap flex-justify-start flex">
    <router-link :to="`/community/posts/${blogpost.url}`" 
    class="font-second cursor-pointer hover:bg-white pd-l-thin pd-r-thin radius-big">
      👁️ {{blogpost.views}}
    </router-link>
    
    <div class="hover:bg-white pd-l-thin pd-r-thin radius-big cursor-pointer">
      <div class="cursor-pointer" @click="addReaction('like')" v-if="!isReacted">
        👍 {{reactionsCount }}
      </div>
      <div class="cursor-pointer" @click="deleteReaction('like')" v-if="isReacted">
        👍 {{reactionsCount }}
      </div>
    </div>
    <a @click="goToComments"
    class="font-second cursor-pointer hover:bg-white pd-l-thin pd-r-thin radius-big">
      💬 {{ blogpost.numberOfComments }}
    </a>
  </footer>
</template>

<script setup="props">
import { computed, ref, getCurrentInstance } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';

import * as reactions from '@martyrs/src/modules/community/store/reactions.js';

const props = defineProps(['blogpost', 'owner', 'user']);

const { t } = useI18n();
const { proxy } = getCurrentInstance();
const router = useRouter();
const route = useRoute();

const reactionsCount = ref(props.blogpost.numberOfReactions);
const isReacted = ref(props.blogpost.isReacted);
const reactionId = ref(props.blogpost.reactionId);

// Неавторизованным — тот же auth-попап, что и у формы комментариев (вместо alert).
function promptAuth() {
  return proxy.$showAuth({
    title: t('community.auth.title'),
    subtitle: t('community.auth.subtitle'),
    returnUrl: route.fullPath,
  });
}

// 💬 внутри самой статьи скроллит к комментариям (не редиректит на тот же роут → без анимации).
function goToComments() {
  if (route.params.url === props.blogpost.url) {
    document.getElementById('comments')?.scrollIntoView({ behavior: 'smooth' });
  } else {
    router.push(`/community/posts/${props.blogpost.url}#comments`);
  }
}

async function addReaction(type) {
  if (!props.user) {
    promptAuth();
    return;
  }

  try {
    const reaction = {
      target: props.blogpost._id,
      type: 'blogpost',
      user: props.user,
      class: 'like'
    };
    const res = await reactions.actions.create(reaction);

    if (res.reaction.class === 'like') {
      reactionsCount.value += 1;
      isReacted.value = true;
      reactionId.value = res.reaction._id;
    }
  } catch (err) {
    console.error(err);
    alert('Error adding reaction. Please try again later.');
  }
}

async function deleteReaction(type) {
  if (!props.user) {
    promptAuth();
    return;
  }

  try {
    const reaction = { _id: reactionId.value };

    await reactions.actions.delete(reaction);

    reactionsCount.value -= 1;
    isReacted.value = false;
    reactionId.value = null;
  } catch (err) {
    alert('Error adding reaction. Please try again later.');
  }
}
</script>

<style lang="scss">
</style>
